
<div class="games-primary-header-wrapper card">

  <div class="header-row mb-1">

    <span class="row-text">Elige uno o varios días</span>

    <div class="days-selection">

      <cdk-virtual-scroll-viewport orientation="horizontal" class="scroll">

        <div class="days">
          @for (game of games; track game) {
            <app-day-lottery class="day" [date]="game" (selectedEvent)="dateSelected($event)" (scrollEvent)="scroll($event)"></app-day-lottery>
          }
        </div>

      </cdk-virtual-scroll-viewport>

    </div>

  </div>

</div>